import { createApp, h } from 'vue';
import Template from './template.vue';

const confirm = (message, options = {}) => {
    const container = document.createElement('div');
    (document.querySelector('[data-v-app=true]') || document.body).appendChild(container);
    return new Promise(resolve => {
        const instance = createApp({
            render() {
                return h(Template, {
                    ...options,
                    message,
                    onDone: (result) => {
                        resolve(result);
                        instance.unmount();
                        container.remove();
                    }
                });
            }
        });
        instance.use(vuetify).mount(container);
    });
}

export function useConfirm() {
    return confirm;
}

export default {
    install: (app) => {
        app.config.globalProperties.$confirm = confirm;
        app.provide('confirm', confirm);
    }
}
